"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _RadioButton = require("material-ui/RadioButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectedIconStyle = {
  fill: "fe7a51"
};

var RadioButtonUi = function RadioButtonUi(_ref) {
  var options = _ref.options,
      valueSelected = _ref.valueSelected,
      className = _ref.className,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      _ref$radioButtonItemS = _ref.radioButtonItemStyle,
      radioButtonItemStyle = _ref$radioButtonItemS === undefined ? {} : _ref$radioButtonItemS,
      _ref$labelItemStyle = _ref.labelItemStyle,
      labelItemStyle = _ref$labelItemStyle === undefined ? {} : _ref$labelItemStyle,
      _ref$labelStyle = _ref.labelStyle,
      labelStyle = _ref$labelStyle === undefined ? {} : _ref$labelStyle,
      _ref$selectedStyle = _ref.selectedStyle,
      selectedStyle = _ref$selectedStyle === undefined ? {} : _ref$selectedStyle,
      handleChange = _ref.handleChange,
      checkedIcon = _ref.checkedIcon,
      iconStyle = _ref.iconStyle,
      selectedLabelStyle = _ref.selectedLabelStyle,
      id = _ref.id,
      disabled = _ref.disabled,
      _ref$showFloatingLabe = _ref.showFloatingLabelText,
      showFloatingLabelText = _ref$showFloatingLabe === undefined ? false : _ref$showFloatingLabe,
      floatingLabelText = _ref.floatingLabelText;

  var renderRadioButtons = function renderRadioButtons() {
    return options.map(function (option, index) {
      var value = option.value,
          label = option.label;

      return _react2.default.createElement(_RadioButton.RadioButton, {
        key: index,
        id: id + "-" + index,
        style: value === valueSelected ? (0, _extends3.default)({}, radioButtonItemStyle, selectedStyle) : radioButtonItemStyle,
        value: value,
        label: label,
        labelStyle: value === valueSelected ? (0, _extends3.default)({}, labelStyle, selectedLabelStyle) : labelStyle,
        iconStyle: value === valueSelected ? (0, _extends3.default)({}, iconStyle, selectedIconStyle) : iconStyle,
        checkedIcon: checkedIcon,
        disabled: disabled
      });
    });
  };

  var styles = {
    labelStyle: {
      font: "12px",
      letterSpacing: 0.6,
      marginBottom: 5,
      marginTop: 14
    }

  };

  var getRadioComponent = function getRadioComponent() {
    if (showFloatingLabelText) {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_translationNode2.default, { label: floatingLabelText, fontSize: 12, labelStyle: styles.labelStyle, bold: true }),
        _react2.default.createElement(
          _RadioButton.RadioButtonGroup,
          {
            valueSelected: valueSelected,
            name: name,
            className: className + " RadioComp",
            onChange: handleChange,
            defaultSelected: defaultValue,
            style: style
          },
          renderRadioButtons()
        )
      );
    } else {
      return _react2.default.createElement(
        _RadioButton.RadioButtonGroup,
        {
          valueSelected: valueSelected,
          name: name,
          className: className + " RadioComp",
          onChange: handleChange,
          defaultSelected: defaultValue,
          style: style
        },
        renderRadioButtons()
      );
    }
  };

  return _react2.default.createElement(
    "div",
    null,
    getRadioComponent()
  );
};

exports.default = RadioButtonUi;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/RadioButton/index.js
// module id = ../lib/egov-ui-kit/components/RadioButton/index.js
// module chunks = 504